export default {
  xeroPersons: [],
  xeroPerson: undefined,
};
